// extracted by mini-css-extract-plugin
export var seperator = "index-module--seperator--Gh3R0";
export var text_wrapper = "index-module--text_wrapper--KavJ8";
export var vision_container = "index-module--vision_container--xwxl+";